import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { editMatriculado } from 'redux/matriculadosSlice';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import PropTypes from 'prop-types';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';

const ActiveMatriculadoModal = ({ user, setShow }) => {
  const dispatch = useDispatch();

  const handleClose = () => setShow(false);

  const handleActive = async () => {
    dispatch(editMatriculado(user.id, { bypassed: true }));

    handleClose();
  };

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon="fa-power-off"
          size="1x"
          title="Activar"
          style={{ marginRight: 8, color: '#00d97e' }}
        />

        <Modal.Title>Activar login directo</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          El usuario{' '}
          <b>
            {user.firstName} {user.lastName}
          </b>{' '}
          podrá ingresar con login directo.
          <br />
          <br />
          ¿Está seguro de confirmar esta acción?.
        </div>

        <ModalButtonsContainer>
          <ButtonClose text="Cerrar" funcion={handleClose} />

          <ButtonAccept text="Activar" funcion={handleActive} />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

ActiveMatriculadoModal.propTypes = {
  user: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired
};

export default ActiveMatriculadoModal;
